<template>
  <CSidebar class="pretest-sidebar" position="fixed" :visible="true">
    <div class="brand">
      <CSidebarBrand>
        <img src="@/assets/images/logo-black.svg" />
      </CSidebarBrand>
    </div>

    <router-link to="/questionnaire" class="message">
      <img style="width:20px" src="@/assets/icons/back.svg" />
      返回
    </router-link>
  </CSidebar>
</template>

<script>
export default {
  name: 'PreTestSidebar',
  setup() {},
}
</script>

<style lang="scss" scoped>
:global(.pretest-sidebar) {
  --cui-sidebar-brand-bg: none;
  --cui-sidebar-color: #4d4d4d;
  border-radius: 0 20px 20px 0;
  border: 1px solid #eff0f6;
  background: #ffffff;
  filter: drop-shadow(0px 5px 20px rgba(0, 0, 0, 0.05));
}
.brand {
  padding: 24px 0;
  img {
    width: 120px;
  }
}
.content-wrapper {
  padding: 0 25px;
}
.selection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px 10px 16px;
  gap: 10px;
  margin-bottom: 35px;
  background: #f3f8fb;
  border-radius: 10px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.154px;
  color: #187baf;
}
.link {
  display: block;
  margin-bottom: 40px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.154px;
  color: #4d4d4d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
}
.edit-options-btn {
  font-size: 14px;
  width: 192px;
  height: 48px;
  display: flex;
  justify-content: left;
  align-items: center;
  color: #177baf;
  border-radius: 4px;
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.message {
  position: absolute;
  bottom: 5rem;
  left: 50%;
  transform: translateX(-50%);
  color: #177baf;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  img {
    margin-right: 10px;
  }
}
</style>
